import { all } from 'redux-saga/effects';
import { authSaga } from './authSaga';
import { guestListSaga } from './guestListSaga';

/** Starts all Redux Saga watchers for the client application. */
export function* rootSaga() {
  yield all([
    authSaga(),
    guestListSaga(),
  ]);
}
